import type { SparePartCatalogEntry } from '../constants/sparePartsCatalog';
import type { StockPieceEtat, StockSelectionItem } from '../types/stockBulk.types';

export interface StockPieceRowForAdd {
  referenceFournisseur: string;
  referenceConstructeur: string;
  constructeur: string;
  etatPiece: string;
  idElementStock: string;
  idPieceDetachee: string;
  referencePieceDetachee: string;
  nomPiece: string;
  fournisseur: string;
  idFournisseur: string;
  idStock: string;
  nomStock: string;
  siteAssocie: string;
  referenceDossier: string;
  idDossier: string;
  emplacementStock: string;
  statutElementStock: string;
  prixVenteTtc: string;
  prixAchatHt: string;
  dateEntreeStock: string;
  dateDerniereMiseAJour: string;
}

const createElementId = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return `poc-stock-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
};

export const buildStockPieceRowsForBulkAdd = ({
  catalogEntry,
  stocks,
  quantity,
  etatPiece,
  emplacementStock,
}: {
  catalogEntry: SparePartCatalogEntry;
  stocks: StockSelectionItem[];
  quantity: number;
  etatPiece: StockPieceEtat;
  emplacementStock: string;
}): StockPieceRowForAdd[] => {
  const safeQuantity = Math.max(1, Math.floor(quantity));
  const emplacementTrimmed = emplacementStock.trim() || '-';
  const rows: StockPieceRowForAdd[] = [];
  const nowIso = new Date().toISOString();

  for (const stock of stocks) {
    for (let unitIndex = 0; unitIndex < safeQuantity; unitIndex += 1) {
      rows.push({
        referenceFournisseur: catalogEntry.referenceFournisseur,
        referenceConstructeur: catalogEntry.referenceConstructeur,
        constructeur: catalogEntry.constructeur,
        etatPiece,
        idElementStock: createElementId(),
        idPieceDetachee: catalogEntry.idPieceDetachee,
        referencePieceDetachee: catalogEntry.referencePieceDetachee,
        nomPiece: catalogEntry.nomPiece,
        fournisseur: catalogEntry.fournisseur,
        idFournisseur: catalogEntry.idFournisseur,
        idStock: stock.idStock,
        nomStock: stock.nomStock,
        siteAssocie: stock.siteAssocie,
        referenceDossier: '-',
        idDossier: createElementId(),
        emplacementStock: emplacementTrimmed,
        statutElementStock: 'Disponible',
        prixVenteTtc: '-',
        prixAchatHt: '-',
        dateEntreeStock: nowIso,
        dateDerniereMiseAJour: nowIso,
      });
    }
  }

  return rows;
};
